import ProjectTreeContainer from "./ProductionTree/index";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import config from "src/config";
import FormikInput from 'src/components/formik/FormikInput';
import FormikTextarea from 'src/components/formik/FormikTextarea';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { postRequest } from 'src/utils/RequestUtil';
import { toast } from 'react-toastify';
import { useCallback, useEffect, useState } from "react";
import { ProductionDefaultProps, ProductionYupSchema } from "./ProductionPropTypes";
import { getTaskProductionCountAPI, productionFIleRemoveAPI, userProductionFileAPI } from "src/api/ProductionApi";
import BreadCrumbs from "./ProductionTree/BreadCrum";
import * as Yup from 'yup';
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { productionResetAction } from "./actions/ProductionActions";
import { useRef } from "react";

const Render = (props) => {
  const {
    files,
    handleRemoveFile,
    handleUploadFile,
    isSubmitting,
    isValid,
    dirty,
    reAppliedId,
    setFieldValue,
    onSelectedNoTaskApi
  } = props;
  // if (!isProduction()) {
  //   withFormikDevtools(props);
  // }  
  // Date custom strat
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const { selectedClient, selectTask } = useSelector(state => state.ProductionReducer, shallowEqual)

  const dateInputRef = useRef(null);  // Create a ref for the input  
  useEffect(() => {
    // Initialize flatpickr and disable time picker
    if (reAppliedId) {
      flatpickr(dateInputRef.current, {
        enableTime: false,  // Disable time picker
        dateFormat: "Y/m/d",  // Date format MM/DD/YYYY
        onChange: (selectedDates, dateStr) => {
          if (selectedDates.length > 0) {
            const selectedDate = selectedDates[0];
            const date = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
            setFieldValue('date', date);
          }
        }
      });
    }

  }, [reAppliedId]);
  useEffect(() => {
    setSelectedNoTask('');
  }, [selectedClient, selectTask]);

  const [selectedNoTask, setSelectedNoTask] = useState(''); // Default value

  const onSelectedNoTask = (event) => {
    onSelectedNoTaskApi(event)
  };

  return (
    <>
      <div className="modal-body pb-0">
        <Form autoComplete="disabled">
          <ProjectTreeContainer onSelectedNoTask={onSelectedNoTask} />


          <BreadCrumbs />
          <div className="row mt-16">
            <div className="col-md-4 mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">Date</label>
              <div className="position-relative">
                {
                  reAppliedId ?
                    (
                      <>
                        <Field
                          className="form-control radius-8 bg-base"
                          id="editstartDate"
                          type="text"
                          name="date" // Link to Formik state using 'name'
                          placeholder="MM/DD/YYYY"
                          innerRef={dateInputRef}  // Attach ref to the input using innerRef
                          onChange={(e) => setFieldValue('date', e.target.value)}  // Manually update the value
                        />
                        <ErrorMessage
                          name="date" // Link ErrorMessage to the 'startDate' field
                          component="div"
                          className="text-danger"
                        />
                      </>
                    ) : (
                      <>
                        <input
                          disabled
                          className="form-control radius-8 bg-base"
                          id="editstartDate"
                          type="text"
                          placeholder={formattedDate}
                          value={formattedDate}
                        />
                      </>
                    )
                }
                <span className="position-absolute end-0 top-50 translate-middle-y me-12 line-height-1">
                  <iconify-icon icon="solar:calendar-linear" className="icon text-lg"></iconify-icon>
                </span>
              </div>
            </div>
            <div className="col-md-4 mb-20">
              <div className="produComment">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">Number in ({(selectTask.targetUnit === "min") ? "Minutes" : "Units"})*</label>
                <div className="proTaskSec my-0 flex-column">
                  <FormikInput
                    type="number"
                    name="totalDurations"
                    className="form-control"
                    placeholder={0}
                  />
                  {/* <span className="proTimeContent">min</span> */}
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-20">
              <div className="produComment w-100">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8 d-block">Attach (.zip file only)</label>
                <div className="attchProMaine d-inline-block mt-0 pt-4">
                  <input
                    type="file"
                    name="file"
                    id="file" className="from-control"
                    // multiple
                    accept=".zip"  // Only allows ZIP files
                    onChange={handleUploadFile}
                  />
                  <label htmlFor="file">
                    <div className="attContent">+ Attachment {" "}
                      <span>
                        <svg
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.4888 6.85102L8.16811 13.1709C7.4703 13.8935 6.52074 14.3192 5.51701 14.3595C4.51328 14.3997 3.53268 14.0514 2.77923 13.387C2.41132 13.0406 2.11674 12.6238 1.91297 12.1614C1.70921 11.699 1.6004 11.2004 1.59302 10.6951C1.58563 10.1898 1.67982 9.68821 1.86999 9.22003C2.06016 8.75186 2.34244 8.32665 2.70007 7.96964L8.0834 2.58631C8.50784 2.17421 9.07738 1.94564 9.66896 1.95001C10.2605 1.95437 10.8266 2.19131 11.245 2.60962C11.6633 3.02794 11.9002 3.59405 11.9046 4.18563C11.9089 4.7772 11.6804 5.34674 11.2683 5.77119L5.88494 11.1545C5.74607 11.2864 5.56187 11.3599 5.37036 11.3599C5.17885 11.3599 4.99465 11.2864 4.85578 11.1545C4.72041 11.0175 4.6445 10.8326 4.6445 10.6399C4.6445 10.4473 4.72041 10.2624 4.85578 10.1254L9.16007 5.82106C9.30872 5.67157 9.3919 5.46914 9.39131 5.25832C9.39071 5.0475 9.3064 4.84555 9.1569 4.69689C9.00741 4.54824 8.80499 4.46506 8.59416 4.46565C8.38334 4.46625 8.18139 4.55057 8.03273 4.70006L3.72844 9.00277C3.29543 9.43712 3.05228 10.0254 3.05228 10.6387C3.05228 11.2521 3.29543 11.8404 3.72844 12.2747C4.16908 12.6954 4.75484 12.9301 5.36403 12.9301C5.97321 12.9301 6.55897 12.6954 6.99961 12.2747L12.3829 6.89139C12.745 6.5364 13.033 6.11315 13.2304 5.64613C13.4278 5.17911 13.5307 4.67759 13.533 4.17057C13.5354 3.66355 13.4372 3.16109 13.2441 2.69226C13.0511 2.22342 12.767 1.79752 12.4083 1.43918C12.0495 1.08084 11.6234 0.797178 11.1543 0.604594C10.6853 0.41201 10.1827 0.314329 9.67572 0.3172C9.1687 0.320072 8.66728 0.423439 8.20046 0.621323C7.73364 0.819207 7.31069 1.10768 6.95607 1.47006L1.57273 6.85339C1.06542 7.36045 0.665137 7.96425 0.395625 8.62896C0.126113 9.29366 -0.00713247 10.0057 0.00379549 10.7229C0.0147234 11.4401 0.169602 12.1478 0.459241 12.804C0.74888 13.4602 1.16738 14.0515 1.6899 14.5429C2.67042 15.4541 3.96298 15.9547 5.30148 15.9417C6.79668 15.9413 8.23048 15.347 9.28753 14.2895L15.6082 7.96885C15.6838 7.89582 15.7441 7.80847 15.7856 7.71188C15.8271 7.61529 15.8489 7.51141 15.8499 7.40629C15.8508 7.30118 15.8307 7.19693 15.7909 7.09964C15.7511 7.00234 15.6923 6.91395 15.618 6.83962C15.5437 6.76529 15.4553 6.70651 15.358 6.6667C15.2607 6.6269 15.1565 6.60686 15.0513 6.60778C14.9462 6.60869 14.8423 6.63053 14.7457 6.67202C14.6492 6.71351 14.5618 6.77382 14.4888 6.84943V6.85102Z"
                            fill="#CC33FF"
                          />
                        </svg></span></div>
                  </label>
                </div>
              </div>

            </div>
          </div>
          <div className="d-block w-100">
            {/* Display File Info Section */}
            {files.length > 0 &&
              files.map((file, index) => (
                <div className="clientDocShow clientDocShowNeFile my-4" key={index}>
                  <div className="cleDocContent">
                    <div className="d-flex align-items-start gap-1">
                      <div className="fileFormat">
                        <span className="bgFilesg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            fill="currentColor"
                            className="bi bi-file-earmark-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2z"></path>
                          </svg>
                        </span>
                        <span className="filefmttext">ZIP</span>
                      </div>
                      <div>
                        <div className="FileName">{file.name}</div>
                        <div className="FileSize">
                          {(file.size / 1024).toFixed(2)} KB
                        </div>
                      </div>
                    </div>
                    <button
                      className="deletFilebtn px-3 py-3 d-flex justify-content-center align-items-center"
                      onClick={() => handleRemoveFile(file)}
                    >
                      <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.30775 17.4997C2.81058 17.4997 2.385 17.3227 2.031 16.9687C1.677 16.6147 1.5 16.1892 1.5 15.692V2.99973H1.25C1.0375 2.99973 0.859417 2.92782 0.71575 2.78398C0.571917 2.64015 0.5 2.46198 0.5 2.24948C0.5 2.03682 0.571917 1.85873 0.71575 1.71523C0.859417 1.57157 1.0375 1.49973 1.25 1.49973H5C5 1.2549 5.08625 1.04624 5.25875 0.873735C5.43108 0.701402 5.63967 0.615234 5.8845 0.615234H10.1155C10.3603 0.615234 10.5689 0.701402 10.7413 0.873735C10.9138 1.04624 11 1.2549 11 1.49973H14.75C14.9625 1.49973 15.1406 1.57165 15.2843 1.71548C15.4281 1.85932 15.5 2.03748 15.5 2.24998C15.5 2.46265 15.4281 2.64073 15.2843 2.78423C15.1406 2.9279 14.9625 2.99973 14.75 2.99973H14.5V15.692C14.5 16.1892 14.323 16.6147 13.969 16.9687C13.615 17.3227 13.1894 17.4997 12.6923 17.4997H3.30775ZM13 2.99973H3V15.692C3 15.7818 3.02883 15.8556 3.0865 15.9132C3.14417 15.9709 3.21792 15.9997 3.30775 15.9997H12.6923C12.7821 15.9997 12.8558 15.9709 12.9135 15.9132C12.9712 15.8556 13 15.7818 13 15.692V2.99973ZM6.15425 13.9997C6.36675 13.9997 6.54483 13.9279 6.6885 13.7842C6.832 13.6404 6.90375 13.4622 6.90375 13.2497V5.74973C6.90375 5.53723 6.83183 5.35907 6.688 5.21523C6.54433 5.07157 6.36617 4.99973 6.1535 4.99973C5.941 4.99973 5.76292 5.07157 5.61925 5.21523C5.47575 5.35907 5.404 5.53723 5.404 5.74973V13.2497C5.404 13.4622 5.47583 13.6404 5.6195 13.7842C5.76333 13.9279 5.94158 13.9997 6.15425 13.9997ZM9.8465 13.9997C10.059 13.9997 10.2371 13.9279 10.3807 13.7842C10.5243 13.6404 10.596 13.4622 10.596 13.2497V5.74973C10.596 5.53723 10.5242 5.35907 10.3805 5.21523C10.2367 5.07157 10.0584 4.99973 9.84575 4.99973C9.63325 4.99973 9.45517 5.07157 9.3115 5.21523C9.168 5.35907 9.09625 5.53723 9.09625 5.74973V13.2497C9.09625 13.4622 9.16817 13.6404 9.312 13.7842C9.45567 13.9279 9.63383 13.9997 9.8465 13.9997Z" fill="#1C1B1F"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              ))}

          </div>
          <div className="produComment">
            <label className="form-label fw-semibold text-primary-light text-sm mb-8">Comment</label>
            <FormikTextarea
              name="comment"
              className="form-control"
              rows={4}
              cols={50}
              placeholder="Write comment here. Minimum 50 characters required."
              defaultValue={""}
            />
          </div>

          <div className="py-16 psstyky bg-white z-9">
            <button
              type="submit"
              className="btn btn-primary w-100 mt-16"
              data-bs-dismiss="modal"
              aria-label="Close"
              disabled={!isValid || !dirty || isSubmitting}
            >
              Submit{" "}
            </button>
          </div>
        </Form>
      </div>

    </>
  );
};


export const AddProductionModal = ({ search, setReAppliedId, reAppliedId, sendDataToParent }) => {
  // Function to format the date
  const { _id: userId } = useSelector(state => state.auth?.user, shallowEqual);
  const { selectedClient, selectedProject, selectTask, selectModule } = useSelector(state => state.ProductionReducer, shallowEqual)
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([])
  const [validationSchema, setValidationSchema] = useState(ProductionYupSchema)

  const [isNoTask, setIsNoTask] = useState('');
  const handleSelectedNoTaskApi = (isNoTask) => {
    setIsNoTask(isNoTask)
  }

  const handleSubmit = useCallback(async (values, { setSubmitting, resetForm }) => {
    setIsLoading(true);
    try {
      if (isNoTask) {
        values.clientId = "66fa7d8526109225f70f5b05"
        values.projectId = "6784fa3e2419afa98731ab89"
        values.taskId = "6784faa02419afa98731ad2b"
        values.moduleId = null
        values.productionSlug = "PROJECT_641>S>No Task"
      } else {
        const productionSlugParts = [
          selectedClient.ClientProjectCode,
          selectedProject.ProjectSubCode,
          selectTask.taskName,
          selectModule.moduleName,
        ];
        values.clientId = selectedClient.clientId
        values.projectId = selectedProject.projectId
        values.taskId = selectTask.taskId
        values.moduleId = selectModule.moduleId
        values.productionSlug = productionSlugParts.filter(Boolean).join('>');
      }
      // const productionSlugParts = [
      //   selectedClient.ClientProjectCode,
      //   selectedProject.ProjectSubCode,
      //   selectTask.taskName,
      //   selectModule.moduleName,
      // ];
      values.reAppliedId = reAppliedId
      values.userId = userId
      // values.clientId = selectedClient.clientId
      // values.projectId = selectedProject.projectId
      // values.taskId = selectTask.taskId
      // values.moduleId = selectModule.moduleId
      // values.productionSlug = productionSlugParts.filter(Boolean).join('>');
      values.files = files
      if (!(await handleExternalValidation(values))) return

      let url = `${config.baseUrl}production/save`;
      if (values.reAppliedId)
        url = `${config.baseUrl}production/re-applied`;

      const result = await postRequest({
        url,
        data: values,
      });

      // Ensure sendDataToParent is a function before calling it
      if (typeof sendDataToParent === "function") {
        sendDataToParent(result?.data?.data); // Send data to parent
      } else {
        console.error("sendDataToParent is not a function");
      }
      toast.success('Production submitted successfully!');
      dispatch(productionResetAction())
      resetForm(); // Reset the form after successful submission
      search();
      setReAppliedId(null)
    } catch (error) {
      console.error(error);
      toast.error('Failed to submit form!');
    } finally {
      setSubmitting(false);
      setIsLoading(false);
    }
  }, [
    files,
    selectedClient,
    selectedProject,
    selectTask,
    selectModule,
    userId,
    isNoTask
  ]);
  const handleExternalValidation = async (values) => {
    // Define the validation schema
    const validationSchema = Yup.object().shape({
      userId: Yup.string().required('Session Expired Please Login Again from the existing panel'),
      projectId: Yup.string().required('Please select a project'),
      taskId: Yup.string().required('Please select a task'),
    });

    try {
      // Validate the values object
      await validationSchema.validate(values, { abortEarly: false });
      return true;
    } catch (errors) {
      // Handle validation errors
      errors.inner.forEach(error => {
        // Display the error message for each field
        toast.error(error.message);
      });
      return false;
    }
  };
  const handleUploadFile = async (event) => {
    const files = event.target.files;
    const payload = { file: files[0], by: userId };
    const fileResponse = await userProductionFileAPI(payload);
    setFiles(prevFiles => [...prevFiles, fileResponse.data.data]);
  };
  const handleRemoveFile = async (data) => {
    const remove = await productionFIleRemoveAPI({ ids: [data._id] })
    if (remove)
      setFiles(files.filter(item => item._id !== data._id))
  }

  // ksjhjk skjfhjkfh jfhd

  // const loadProjectIntoTree = async (projectId) => {
  //   const projects = await getProjectForClientDeliveryFromAPI(projectId)
  //   dispatch(productionProjectAssigneeSearchAction({
  //     data: projects.data.data
  //   }));
  // }

  // useEffect(() => {
  //   getProductionList();
  //   loadProjectIntoTree(projectId);
  // }, [projectId]);

  useEffect(() => {
    // Initialize Bootstrap tooltips for elements with data-bs-toggle="tooltip"
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

    // Cleanup tooltips when the component unmounts
    return () => {
      tooltipList.forEach(tooltip => tooltip.dispose());
    };
  }, []);
  useEffect(() => {
    const fetchTaskProductionCount = async () => {
      if (selectTask.item === "Bound") {
        try {
          const productionCountResponse = await getTaskProductionCountAPI(selectTask.taskId, selectModule.moduleId);
          const totalProduction = productionCountResponse.data.total;
          const dynamicMax = (selectTask.target - totalProduction);
          const validationSchema = Yup.object().shape({
            totalDurations: Yup.number()
              .min(0, 'Duration cannot be negative')
              .max(dynamicMax, `Duration cannot exceed more than ${dynamicMax}`)
              .required('Duration is required'),
          });

          setValidationSchema(validationSchema);
        } catch (error) {
          console.error("Error fetching task production count:", error);
        }
      } else {
        setValidationSchema(ProductionYupSchema);
      }
    };

    fetchTaskProductionCount(); // Call the async function

  }, [selectTask.taskId, selectTask.item, selectTask.target, selectModule.moduleId]);
  return (


    <div
      className="modal fade pcdModal producSecMAin cusmodl"
      id="addProduction"
      tabIndex={-1}
      aria-labelledby="addClientDeliverySec"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title" id="addClientDeliverySec">
              Add Today Work details
            </h1>
            <button
              type="button"
              className="close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              ✗
            </button>
          </div>

          <Formik
            initialValues={ProductionDefaultProps}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {(formikProps) => (
              <Render
                {...formikProps}
                files={files}
                reAppliedId={reAppliedId}
                handleUploadFile={handleUploadFile}
                handleRemoveFile={handleRemoveFile}
                onSelectedNoTaskApi={handleSelectedNoTaskApi}
              />
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}